import { Box, Typography } from '@mui/material';

import { FSimpleDialog, F_SIMPLE_DIALOG_VARIANT } from '../../../../../components/baseV2/fSimpleDialog';
import { FORTA_ERROR } from '../../../../../utils/colors';

import type { ConcludeErrorsDialogProps } from './types';

export default function ConcludeErrorsDialog({
  open,
  pageLabels,
  onClose,
}: ConcludeErrorsDialogProps) {
  return (
    <FSimpleDialog
      open={open}
      onClose={onClose}
      variant={F_SIMPLE_DIALOG_VARIANT.WARNING}
      title="Please complete the following forms to proceed."
      titleSx={{ fontSize: 18 }}
      cancelText="Close"
      onCancel={onClose}
    >
      <Box component="ul" sx={{ p: 3, m: 0 }}>
        {pageLabels.map((label) => (
          <Typography key={label} component="li" sx={{ color: FORTA_ERROR, fontWeight: 700 }}>
            {label}
          </Typography>
        ))}
      </Box>
    </FSimpleDialog>
  );
}
